import { selectFromVisitDto } from '../../models';

export default selectFromVisitDto()
  .name
  .uuid
  .eventUuid
  .load
  .isPriority
  .isCompleted
  .isScheduled
  .pendingTargetRouteUuid
  .isDateMismatched
  .customerOrderNumber
  .rating(rating => rating.rate.comment)
  .attempts(attempt => attempt
    .orderUuid
    .eventUuid
    .status
    .latitude
    .longitude
    .distanceFromOrder
    .photos(photo => photo.url.thumbnail)
    .signature(signature => signature.base64Png)
    .scannedPackages(pkg => pkg.uuid.scannedTime.barcode)
    .notes
    .date
    .reattemptRequestDate)
  .timeWindows(timeWindow => timeWindow.id.startTime.endTime)
  .locations(location => location.id.address.originalAddress.bestMatch.active.latitude.longitude)
  .packages(pkg => pkg.uuid.barcode)
  .toString();
